/* RESPONSIBLE TEAM: team-reporting */
import { buildValidations, validator } from 'ember-cp-validations';

export default buildValidations({
  name: [validator('presence', true), validator('length', { max: 160 })],
  description: validator('length', { max: 160 }),
});
